<template>
  <div class="friend-choose-panel-main">
    <div class="selected-body custom-scroll">
      <div class="selected-body-inner">
        <ul class="selected-list">
          <li class="item" v-for="(item, index) in selectPanel" @click="item.selected = false" :key="item.id" :title="item.name"
              @mouseenter="closeIconMouseenter($event)" @mouseleave="closeIconMouseleave($event)">
            <span class="name">{{ item.name }}</span>
            <span class="remove"></span>
          </li>
        </ul>
      </div>
    </div>
    <div class="title">
      <span><slot name="title">选择好友</slot></span>
      <span class="tips">
        已选
        <span :style="limit > 0 && selectPanel.length >= limit ? 'color: orangered;' : ''">{{ selectPanel.length }}{{ limit > 0 ? ("/" + limit) : ""}}</span>
        位好友
      </span>
      <div class="close">
        <el-button size="mini" type="success" round v-if="model === 1" @click="change">确定</el-button>
      </div>
    </div>
    <div class="select-panel">
      <div class="left">
        <div class="search">
          <el-input
            placeholder="好友搜索"
            v-model="search"
            clearable>
          </el-input>
        </div>
        <div class="group custom-scroll" v-show="!search">
          <ul>
            <li class="item" v-for="(item, index) in data" @click="clickGroup(index)" :style="checkGroupIndex === index ? {background: '#c2d1f2'} : {}" :key="item.id">
              <i class="checkbox" :class="item.list.length !== 0
              ? (selectedCount[index] > 0 ? (selectedCount[index] < item.list.length ? 'half' : 'full') : 'empty')
              : 'disabled'" @click="selectAll(item)"></i>
              <span class="group-name">{{ item.groupname }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="right custom-scroll">
        <ul class="item-ul" v-for="(item, index) in data" v-show="checkGroupIndex === index && item.list.length > 0 && !search" v-if="item.initFlag" :key="item.id">
          <li class="item" v-for="(i, ii) in item.list" @click="select(i)" :title="i.name" :key="ii"
              @mouseenter="friendMouseenter($event)" @mouseleave="friendMouseleave($event)">
            <el-image :src="i.avatar" lazy fit="contain" class="avatar"></el-image>
            <span class="name">{{ i.name }}</span>
            <i class="checkbox full" v-show="i.selected"></i>
          </li>
        </ul>
        <img class="empty-img" src="/static/img/friend-group_empty.png" v-show="!search && clickEmptyGroup"/>
        <img class="empty-img" src="/static/img/no-friends-in-search.png" v-show="search && searchList.length === 0"/>
        <ul v-if="search" class="item-ul">
          <li  class="item" :key="item.id" v-for="item in searchList"  @click="select(item)" :title="item.name"
              @mouseenter="friendMouseenter($event)" @mouseleave="friendMouseleave($event)">
            <el-image :src="item.avatar" lazy fit="fill" class="avatar"></el-image>
            <span class="name">{{ item.name }}</span>
            <el-checkbox v-model="item.selected" class="checkbox" v-show="item.selected"
                         @change="select(item)"></el-checkbox>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
    import bus from "../../js/bus/bus";
    import { uuid } from "../../js/utils/uuid"
    export default {
        name: "FriendChoose",
        props: {
            /**
             * 默认选中值
             */
            selected: {
                type: Array,
                default: []
            },
            /**
             * 组件模式
             * 1: 手动确认模式，点击确认后调用change事件，通知父组件获得选中值
             * 2：随动模式，勾选改变后调用change事件，通知父组件获得选中值
             */
            model: {
                type: Number,
                default: 1,
            },
            /**
             * 勾选人数限制 小于0不限制
             */
            limit: {
                type: Number,
                default: 0
            }
        },
        created() {
            //监听回调
            bus.$on(this.id, (arr) => {
                let selected = this.selected;
                this.data = arr.map((item, index) => {
                    return {
                        id: item.id,
                        groupname: item.groupname,
                        initFlag: index === 0,
                        selectAll: false,
                        list: item.list.map((i) => {
                            return {id: i.id, name: i.username, avatar: i.avatar, selected: selected.indexOf(i.id) !== -1, sort: 0}
                        })
                    }
                });
            });
            //refresh
            this.refresh();
        },
        destroyed() {
            bus.$off(this.id);
        },
        data() {
            return {
                id: uuid(),
                data: [],
                search: "",
                checkGroupIndex: 0,
                sort: 0,
            }
        },
        methods: {
            //刷新好友分组数据
            refresh() {
                //通讯IM组件获取所有好友列表
                bus.$emit("getClasses", this.id);
            },
            closeIconMouseenter({currentTarget}) {
                currentTarget.lastElementChild.style["background-position"] = '-603px -281px';
            },
            closeIconMouseleave({currentTarget}) {
                currentTarget.lastElementChild.style["background-position"] = '';
            },
            clickGroup(index) {
                this.checkGroupIndex = index;
                if (!this.data[index].initFlag) {
                    this.data[index].initFlag = true;
                }
            },
            //全选某个分组
            selectAll(item) {
                let cs = item.list;
                if (item.selectAll) {
                    for (let i = 0; i < cs.length; i++) {
                        cs[i].selected = false;
                    }
                    item.selectAll = false;
                } else {
                    for (let i = 0; i < cs.length; i++) {
                        if (!cs[i].selected && this.isFull()) {
                            break;
                        }
                        cs[i].selected = true;
                        cs[i].sort = ++this.sort;
                        if (i === cs.length - 1) {
                            item.selectAll = true;
                        }
                    }
                }
                if (this.model === 2) {
                    this.change();
                }
            },
            friendMouseenter({currentTarget}) {
                currentTarget.style["background-image"] = "url(/static/img/icons.png)";
            },
            friendMouseleave({currentTarget}) {
                currentTarget.style["background-image"] = "";
            },
            select(item) {
                if (!item.selected && this.isFull()) {
                    return;
                }
                item.selected = !item.selected;
                item.sort = ++this.sort;
                //检查是否某分组是否勾选全部
                for (let i = 0; i < this.data.length; i++) {
                    let l;
                    this.data[i].selectAll = (l = this.data[i].list.length) !== 0 && l === this.selectedCount[i];
                }
                if (this.model === 2) {
                    this.change();
                }
            },
            change() {
                this.$emit("change", this.selectPanel.map((item) => {
                    return {id: item.id, name: item.name}
                }));
            },
            //检查是否达到勾选上限
            isFull() {
                return this.limit > 0 ? (this.selectPanel.length >= this.limit) : false;
            },

        },
        computed: {
            selectPanel: function () {
                let data = this.data;
                let result = [];
                for (let i = 0; i < data.length; i++) {
                    for (let j = 0; j < data[i].list.length; j++) {
                        if (data[i].list[j].selected) {
                            result.push(data[i].list[j]);
                        }
                    }
                }
                return result.sort(function (a, b) {
                    return a.sort > b.sort ? 1 : (a.sort < b.sort ? -1 : 0)
                });
            },
            //计算每个分组当前所选好友数量
            selectedCount: function () {
                let data = this.data;
                let result = [];
                for (let i = 0; i < data.length; i++) {
                    let count = 0;
                    for (let j = 0; j < data[i].list.length; j++) {
                        if (data[i].list[j].selected) {
                            count++;
                        }
                    }
                    result.push(count);
                }
                return result;
            },
            searchList: function () {
                let data = this.data;
                let value = this.search;
                let result = [];
                for (let i = 0; i < data.length; i++) {
                    for (let j = 0; j < data[i].list.length; j++) {
                        if (data[i].list[j].name.indexOf(value) !== -1) {
                            result.push(data[i].list[j])
                        }
                    }
                }
                return result;
            },
            clickEmptyGroup: function () {
                let data = this.data;
                let checkGroupIndex = this.checkGroupIndex;
                for (let i = 0; i < data.length; i++) {
                    if (checkGroupIndex === i && data[i].list.length === 0) {
                        return true;
                    }
                }
                return false;
            },
        },
    }
</script>

<style scoped>
  @import '../../css/space_common.css';

  .friend-choose-panel-main {
    border: 1px solid #E6E6E6;
    border-radius: 2px;
    width: 600px;
    position: relative;
    box-shadow: 0 0 20px rgba(0, 0, 0, .2);
  }

  .title {
    height: 50px;
    line-height: 50px;
    padding: 0 25px;
    border-bottom: 1px solid #e5e9ef;
    box-sizing: border-box;
    background-color: #F2F2F2;
  }

  .title .tips {
    font-size: 12px;
    color: #999;
  }

  .close {
    float: right;
  }

  .selected-body {
    height: 74px;
    border-bottom: 1px dashed #ccc;
    padding: 10px;
    background-color: white;
    overflow-y: auto;
  }


  .selected-list .item {
    float: left;
    margin: 0 8px 8px 0;
    background-color: #D2E8F9;
    border: 1px solid #B4D3EB;
    border-radius: 10px;
    padding: 0 8px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .selected-list .item .name {
    margin-right: 5px;
  }

  .selected-list .item .remove {
    width: 9px;
    height: 9px;
    display: inline-block;
    background-image: url(/static/img/icons.png);
    background-position: -539px -281px;
  }

  .select-panel {
    display: flex;
  }

  .select-panel .left,.right{
    height: 220px;
    overflow-y: auto;
    user-select: none;
  }


  .select-panel .left {
    width: 180px;
    background-color: #F2F2F2;
    display: flex;
    flex-direction: column;
    padding: 10px 0;
  }

  .select-panel .left .search {
    padding: 0 20px 10px 20px;
  }

  .select-panel .left .group {
    overflow-y: auto;
    flex: 1;
  }

  .select-panel .left .group .item {
    line-height: 26px;
    padding: 0 20px;
    cursor: pointer;
    white-space: nowrap;
    word-wrap: normal;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .select-panel .right {
    background-color: white;
    flex: 1;
    display: flex;
    align-items: center;
  }
  .select-panel .right .empty-img{
    margin: 0 auto;
    font-size: 0;
  }

  .select-panel .right .item-ul {
    display: flex;
    flex-wrap: wrap;
    font-size: 0;
    padding: 10px 0 0 10px;
    align-self: flex-start;
  }

  .select-panel .right .item-ul .item {
    position: relative;
    margin: 0 10px 10px 0;
    cursor: pointer;
    padding: 5px;
    background-position: -814px -40px;
    user-select: none;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
  }

  .select-panel .right .avatar {
    height: 30px;
    width: 30px;
    margin-right: 5px;
  }

  .select-panel .right .name {
    float: right;
    width: 75px;
    white-space: nowrap;
    word-wrap: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
  }

  .checkbox {
    background-image: url(/static/img/icons.png);
    width: 14px;
    height: 14px;
    display: inline-block;
    border-radius: 2px;
    cursor: pointer;
  }

  .checkbox.empty {
    background-position: -593px -959px;
    background-color: white;
  }
  .checkbox.disabled {
    background-position: -593px -1049px;
  }
  .checkbox.full {
    background-position: -593px -989px;
  }
  .checkbox.half {
    background-position: -593px -1019px;
  }

  .select-panel .right .item .checkbox {
    position: absolute;
    right: 3px;
    bottom: 3px;
  }
  .select-panel .left .checkbox {
    vertical-align: middle;
  }
</style>




// WEBPACK FOOTER //
// src/view/baseComponent/FriendChooseV2.vue